import { useState } from 'react';
import { Form } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { Mileage } from '@/models/entities/lead';
import Actions from '@/models/ui/actions.ts';
export interface LeadOdometerProps {
  readonly initialValue?: Mileage | null;
  readonly readonly?: boolean;
}
export function LeadOdometer({
  initialValue = null,
  readonly = false,
}: LeadOdometerProps) {
  const [value, setValue] = useState<number | ''>(initialValue?.value ?? '');
  const [unit, setUnit] = useState<'mi' | 'km'>(initialValue?.unit ?? 'mi');
  const handleCancel = () => {
    setValue(initialValue?.value ?? '');
    setUnit(initialValue?.unit ?? 'mi');
  };
  return (
    <section aria-labelledby="odometer-title">
      <header>
        <h3
          id="odometer-title"
          className="inline-block bg-[#e8e8e8] px-2 py-1 text-xs font-semibold rounded mb-2"
        >
          ODOMETER
        </h3>
        <div className="border-b border-gray-300 mb-4" aria-hidden="true"></div>
      </header>
      <Form method="post">
        <label
          htmlFor="lead-odometer-input"
          className="block text-xs font-semibold mb-2"
        >
          Odometer Reading
        </label>
        <div className="flex gap-2 items-center mb-2">
          <div className="flex w-full items-center">
            <Input
              id="lead-odometer-input"
              name="odometerValue"
              type="number"
              min={0}
              placeholder="Enter mileage"
              disabled={readonly}
              className="text-xs bg-white rounded-r-none focus-visible:ring-0 focus-visible:ring-offset-0 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
              value={value}
              onChange={(e) =>
                setValue(e.target.value === '' ? '' : Number(e.target.value))
              }
              aria-describedby="odometer-unit"
            />
            <Select
              value={unit}
              onValueChange={(v) => setUnit(v as 'mi' | 'km')}
              disabled={readonly}
            >
              <SelectTrigger
                id="odometer-unit"
                className="w-[72px] rounded-l-none border-l-0 focus:ring-0 focus-visible:ring-0 focus-visible:ring-offset-0 text-xs"
              >
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="mi">mi</SelectItem>
                <SelectItem value="km">km</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <input type="hidden" name="odometerUnit" value={unit} />
        </div>
        <div className="flex justify-end gap-2">
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="text-xs"
            onClick={handleCancel}
            disabled={readonly}
          >
            CANCEL
          </Button>
          <Button
            type="submit"
            name="action"
            value={Actions.UpdateOdometer.key}
            size="sm"
            className="bg-[#2d2d2d] hover:bg-[#1d1d1d] text-white text-xs"
            disabled={readonly}
          >
            {Actions.UpdateOdometer.label}
          </Button>
        </div>
      </Form>
    </section>
  );
}
